import React from 'react'
import SubSection from 'components/common/SubSection'
import AppComponent from 'components/common/AppComponent'
import { MenuItem } from 'constants/Menu'

const pathElements = [
    {id: 0, title: "Home", url: "/"},
    {id: 1, title: "Organisation"}
];

export default class Organisation extends AppComponent {

    render() {

        const menuItem =this.context.menu.find((section) => section.id === MenuItem.ORGANISATION);

        return (
            <SubSection pathElements={pathElements} item={menuItem} />
        );

    }
}